module.exports = __webpack_public_path__ + "img/luis-pereira.cf258002.jpg";